//components
import MediaInfo from "../../Components/MediaInfo/MediaInfo";

// data
import mediaData from "./mediaData";

//styling
import "../../Styling/section.scss";
import "./media.scss";

function Media() {
    const sortedMediaData = [...mediaData].sort((a,b)=> b.endDate.getTime() - a.endDate.getTime());

    return (
        <section className="events">
            <h2 className="events__Title">Media</h2>
            {sortedMediaData.length > 0 && <>
                {sortedMediaData.map((media, index) => (
                    <MediaInfo key={`${media.name}-${index}`} name={media.name} linkUrl={media.linkUrl} linkText={media.linkText} />))
                }
            </>}
        </section>
    )
}

export default Media;